import React, { useState } from "react";
import { Sidebar } from "./Sidebar";
import { Header } from "./Header";

export default function AppLayout({ children, headerProps = {} }) {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);

  return (
    <div className="h-screen w-full bg-[#131110] text-stone-200 flex overflow-hidden">
      {/* Sidebar with direct state control */}
      {isSidebarOpen && <Sidebar />}

      {/* Main Container */}
      <div className="flex-1 flex flex-col min-w-0 h-full overflow-hidden">
        <Header
          isSidebarOpen={isSidebarOpen}
          onToggleSidebar={() => setIsSidebarOpen((prev) => !prev)}
          {...headerProps}
        />
        <main className="flex-1 p-5 h-full overflow-y-auto [&::-webkit-scrollbar]:w-2 [&::-webkit-scrollbar-track]:bg-[#131110] [&::-webkit-scrollbar-thumb]:bg-[#2a241e] [&::-webkit-scrollbar-thumb]:rounded-full hover:[&::-webkit-scrollbar-thumb]:bg-amber-500">{children}</main>
      </div>
    </div>
  );
}